import { useNavigate } from "react-router-dom";
import Logo from "../design/Logo";
import CardText from "../design/CardText";
import CardTextNumber from "../design/CardTextNumber";

const CreateLearningPlay = () => {
  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-10 mx-auto lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
            <div className="text-3xl font-bold mb-5">창작학습 하기📚💬</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreateLearningPlay;
